import React, { useEffect, useState } from 'react';

import ExternalLink from 'components/ExternalLink/ExternalLink';
import { Badge } from 'antd';

import { MainContainer, StyledAvatar, StyledTab } from './Header.styles';

import { SPECIAL_HOST_IDS } from 'utils/constants';

const Header = ({ hostHomepageUrl, hostImageURL, onOpenDrawer, count, hideDrawer = false, hostId }) => {
  const [isSpecialHost, setIsSpecialHost] = useState(false);

  useEffect(() => {
    const SpecialHostCheck = SPECIAL_HOST_IDS.includes(hostId);

    setIsSpecialHost(SpecialHostCheck);
  }, [hostId]);

  return (
    <MainContainer>
      <span>
        <ExternalLink to={hostHomepageUrl}>
          {isSpecialHost ? (
            <img
              src={require('../../../../images/msu-logo.jpg')}
              alt="MSU Logo"
              style={{
                width: '100%',
                height: 120
              }}
            />
          ) : (
            <StyledAvatar size={{ xs: 140, sm: 140, md: 150, lg: 110, xl: 100, xxl: 80 }} src={hostImageURL} />
          )}
        </ExternalLink>
      </span>
      {!hideDrawer && (
        <span onClick={onOpenDrawer}>
          <Badge count={count} offset={[10]}>
            <StyledTab>MY BOOKING</StyledTab>
          </Badge>
        </span>
      )}
    </MainContainer>
  );
};

export default Header;
